import { ReactNode } from "react";

import { Box } from "@mui/material";

import { useTranslation } from "@/translations";

import { CalendarNavigation } from "./components/navigation/CalendarNavigation";

interface Props {
  onPrevClick: () => void;
  onNextClick: () => void;
  onTodayClick: () => void;
  customHeaderFilter?: ReactNode;
}

export function WeekCalendarHeader({ onPrevClick, onNextClick, onTodayClick, customHeaderFilter }: Props) {
  const { t } = useTranslation();
  return (
    <Box
      role="toolbar"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      py={0.5}
      px={1}
      bgcolor="fsw.blue-5"
      gap={2}
      minHeight={"40px"}
      maxHeight={"40px"}
      aria-label={t("calendar.weekCalendarHeader")}
    >
      <Box display={"flex"} height={"100%"} alignItems="center" gap={1}>
        <CalendarNavigation
          onPrevClick={onPrevClick}
          onNextClick={onNextClick}
          onTodayClick={onTodayClick}
          previousLabel={t("calendar.previousWeek")}
          nextLabel={t("calendar.nextWeek")}
        />
      </Box>
      <Box display={"flex"} height={"100%"} alignItems="center" gap={1}>
        {customHeaderFilter}
      </Box>
    </Box>
  );
}
